import { render, staticRenderFns } from "./GetBusinessXLS.vue?vue&type=template&id=4be7d39c"
import script from "./GetBusinessXLS.vue?vue&type=script&lang=js"
export * from "./GetBusinessXLS.vue?vue&type=script&lang=js"
import style0 from "./GetBusinessXLS.vue?vue&type=style&index=0&id=4be7d39c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports